import { Component, OnInit } from '@angular/core';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TidyStorage } from "src/shared/providers/tidy-storage";
import { GuestReservations } from 'src/providers/guest-reservations/guest-reservations';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { DirectIntegrationOnboardingComponent } from '../direct-integration/direct-integration-onboarding.component';
import { AddDirectIntegrationOnboardingComponent } from '../add-direct-integration/add-direct-integration-onboarding.component';
import { WindowService } from 'src/shared/providers/window.service';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';
import { IntegrationsPage } from 'src/pages/integrations/integrations/integrations';

@Component({
    selector: 'select-integration-onboarding',
    templateUrl: './select-integration-onboarding.html',
    styleUrls: ['./select-integration-onboarding.scss'],
    standalone: false
})

export class SelectIntegrationOnboarding implements OnInit {

  typeItems = [
    {
      viewValue: 'Yes',
      value: 'yes'
    },
    {
      viewValue: 'No',
      value: 'no'
    }
  ];
  primaryTypeItems = [
    {
      viewValue: 'AirBnB',
      value: 'airbnb'
    },
    {
      viewValue: 'VRBO',
      value: 'vrbo'
    }
  ];
  form: UntypedFormGroup;
  submitted = false;

  
  boundGoToAddIntegrationPage = this.goToAddIntegrationPage.bind(this);
  boundSkipAndViewAllIntegrations = this.skipAndViewAllIntegrations.bind(this);

constructor(
    private guestReservations: GuestReservations,
    private onboardingProvider: OnboardingProvider,
    private formBuilder: UntypedFormBuilder,
    private storage: TidyStorage,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService
  ) {
    this.form = this.formBuilder.group({
      type: [null, Validators.required],
      primaryType: [null]
    });
  }

  ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Integrate');
  }

  async goToAddIntegrationPage() {
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }
    if (this.form.value.type === 'yes') {
      await this.storage.save('cameFromIntegrateOnboarding', true);
      await this.storage.save('cameFromPropertyOnboarding', false);
      this.rightSidePanelService.setDialogPageTitle('Connect Integration');
      this.rightSidePanelService.navigateTo('onboarding/directIntegration', {}, DirectIntegrationOnboardingComponent);
    } else if (this.form.value.primaryType === 'airbnb') {
      const integration = await this.getIntegration('Airbnb');
      await this.storage.save('reservationSrcType', integration);
      this.rightSidePanelService.setDialogPageTitle('Add Integration');
      this.rightSidePanelService.navigateTo('onboarding/addDirectIntegration', {}, AddDirectIntegrationOnboardingComponent);
    } else if (this.form.value.primaryType === 'vrbo') {
      const integration = await this.getIntegration('Vrbo');
      await this.storage.save('reservationSrcType', integration);
      this.rightSidePanelService.setDialogPageTitle('Add Integration');
      this.rightSidePanelService.navigateTo('onboarding/addDirectIntegration', {}, AddDirectIntegrationOnboardingComponent);
    }
  }

  async getIntegration(integrationType: string) {
    const allIntegrations = await this.guestReservations.getSourceTypes();
    const filteredIntegrations = this.filterToShowOneIntegrationPerType(allIntegrations);
    const integration = filteredIntegrations.find(int => int.name === integrationType);
    return integration;
  }

  filterToShowOneIntegrationPerType(allIntegrations) {
    const filteredIntegrations: any = [];
    allIntegrations.map((integration) => {
      const alreadyAddedIndex = filteredIntegrations.findIndex(item => item.name === integration.name);
      if (alreadyAddedIndex !== -1) {
        filteredIntegrations[alreadyAddedIndex]['formats'].push(integration.format);
        filteredIntegrations[alreadyAddedIndex]['integrations'].push(integration);
        integration.active_details.map((detail) => {
          filteredIntegrations[alreadyAddedIndex]['active_details'].push(detail);
        });
      } else {
        filteredIntegrations.push({
          formats: [integration.format],
          integrations: [integration],
          ...integration
        });
      }
    });
    return filteredIntegrations;
  }

  onTypeChange() {
    if (this.form.value.type === 'no') {
      this.form.get('primaryType')?.setValidators([Validators.required]);
    } else {
      this.form.get('primaryType')?.clearValidators();
    }
    this.form.get('primaryType')?.updateValueAndValidity();
  }

  async skipAndViewAllIntegrations() {
    // Mark the goal as completed (user can still access integrations later)
    await this.onboardingProvider.markGoalAsCompleted('selectIntegration');
    // Navigate back to onboarding and show in header for later access
    this.navCtrl.navigateForward('integration/all');
    this.onboardingProvider.setShowOnboardingInHeader(true);
  }

}
